export default "__VITE_ASSET__093011c6__"